<template>
    <section class="skills section" id="skills">
        <h2 class="section__title">Skills</h2>
        <span class="section__subtitle">My technical level</span>

        <div class="skills_container container grid">
            <!-- Frontend Skills -->
            <div>
                <div class="skills__content skills__close">
                    <div class="skills__header">
                        <i class="uil uil-brackets-curly skills__icon"></i>
                        <div>
                            <h3 class="skills__title">Frontend Developer</h3>
                            <span class="skills__subtitle">More than 2 years</span>
                        </div>
                        <i class="uil uil-angle-down skills__arrow"></i>
                    </div>
                    <div class="skills__list grid">
                        <div class="skills__data">
                            <div class="skills__titles">
                                <h3 class="skills_name">React & HTML/CSS</h3>
                                <span class="skills__number">85%</span>
                            </div>
                            <div class="skills__bar">
                                <span class="skills__percentage skills__react"></span>
                            </div>
                        </div>
                        <div class="skills__data">
                            <div class="skills__titles">
                                <h3 class="skills_name">JavaScript</h3>
                                <span class="skills__number">90%</span>
                            </div>
                            <div class="skills__bar">
                                <span class="skills__percentage skills__javascript"></span>
                            </div>
                        </div>
                        <div class="skills__data">
                            <div class="skills__titles">
                                <h3 class="skills_name">TypeScript</h3>
                                <span class="skills__number">80%</span>
                            </div>
                            <div class="skills__bar">
                                <span class="skills__percentage skills__typescript"></span>
                            </div>
                        </div>
                        <div class="skills__data">
                            <div class="skills__titles">
                                <h3 class="skills_name">Tailwind CSS</h3>
                                <span class="skills__number">75%</span>
                            </div>
                            <div class="skills__bar">
                                <span class="skills__percentage skills__tailwind"></span>
                            </div>
                        </div>
                        <div class="skills__data">
                            <div class="skills__titles">
                                <h3 class="skills_name">Bootstrap</h3>
                                <span class="skills__number">70%</span>
                            </div>
                            <div class="skills__bar">
                                <span class="skills__percentage skills__bootstrap"></span>
                            </div>
                        </div>
                        <div class="skills__data">
                            <div class="skills__titles">
                                <h3 class="skills_name">Flutter</h3>
                                <span class="skills__number">75%</span>
                            </div>
                            <div class="skills__bar">
                                <span class="skills__percentage skills__flutter"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Backend Skills -->
            <div>
                <div class="skills__content skills__open">
                    <div class="skills__header">
                        <i class="uil uil-server-network skills__icon"></i>
                        <div>
                            <h3 class="skills__title">Backend Developer</h3>
                            <span class="skills__subtitle">More than 2 years</span>
                        </div>
                        <i class="uil uil-angle-down skills__arrow"></i>
                    </div>
                    <div class="skills__list grid">
                        <div class="skills__data">
                            <div class="skills__titles">
                                <h3 class="skills_name">Node.js</h3>
                                <span class="skills__number">90%</span>
                            </div>
                            <div class="skills__bar">
                                <span class="skills__percentage skills__nodejs"></span>
                            </div>
                        </div>
                        <div class="skills__data">
                            <div class="skills__titles">
                                <h3 class="skills_name">Express.js</h3>
                                <span class="skills__number">85%</span>
                            </div>
                            <div class="skills__bar">
                                <span class="skills__percentage skills__express"></span>
                            </div>
                        </div>
                        <div class="skills__data">
                            <div class="skills__titles">
                                <h3 class="skills_name">REST API</h3>
                                <span class="skills__number">90%</span>
                            </div>
                            <div class="skills__bar">
                                <span class="skills__percentage skills__restapi"></span>
                            </div>
                        </div>
                        <div class="skills__data">
                            <div class="skills__titles">
                                <h3 class="skills_name">PHP</h3>
                                <span class="skills__number">75%</span>
                            </div>
                            <div class="skills__bar">
                                <span class="skills__percentage skills__php"></span>
                            </div>
                        </div>
                        <div class="skills__data">
                            <div class="skills__titles">
                                <h3 class="skills_name">Python</h3>
                                <span class="skills__number">70%</span>
                            </div>
                            <div class="skills__bar">
                                <span class="skills__percentage skills__python"></span>
                            </div>
                        </div>
                        <div class="skills__data">
                            <div class="skills__titles">
                                <h3 class="skills_name">Java</h3>
                                <span class="skills__number">60%</span>
                            </div>
                            <div class="skills__bar">
                                <span class="skills__percentage skills__java"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Database Skills -->
            <div>
                <div class="skills__content skills__close">
                    <div class="skills__header">
                        <i class="uil uil-database skills__icon"></i>
                        <div>
                            <h3 class="skills__title">Database Management</h3>
                            <span class="skills__subtitle">More than 2 years</span>
                        </div>
                        <i class="uil uil-angle-down skills__arrow"></i>
                    </div>
                    <div class="skills__list grid">
                        <div class="skills__data">
                            <div class="skills__titles">
                                <h3 class="skills_name">MySQL</h3>
                                <span class="skills__number">85%</span>
                            </div>
                            <div class="skills__bar">
                                <span class="skills__percentage skills__mysql"></span>
                            </div>
                        </div>
                        <div class="skills__data">
                            <div class="skills__titles">
                                <h3 class="skills_name">MongoDB</h3>
                                <span class="skills__number">80%</span>
                            </div>
                            <div class="skills__bar">
                                <span class="skills__percentage skills__mongodb"></span>
                            </div>
                        </div>
                        <div class="skills__data">
                            <div class="skills__titles">
                                <h3 class="skills_name">SQLite</h3>
                                <span class="skills__number">75%</span>
                            </div>
                            <div class="skills__bar">
                                <span class="skills__percentage skills__sqlite"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Cloud & DevOps Tools -->
            <div>
                <div class="skills__content skills__close">
                    <div class="skills__header">
                        <i class="uil uil-share-alt skills__icon"></i>
                        <div>
                            <h3 class="skills__title">Cloud & Deployment</h3>
                            <span class="skills__subtitle">More than 1 year</span>
                        </div>
                        <i class="uil uil-angle-down skills__arrow"></i>
                    </div>
                    <div class="skills__list grid">
                        <div class="skills__data">
                            <div class="skills__titles">
                                <h3 class="skills_name">Docker</h3>
                                <span class="skills__number">75%</span>
                            </div>
                            <div class="skills__bar">
                                <span class="skills__percentage skills__docker"></span>
                            </div>
                        </div>
                        <div class="skills__data">
                            <div class="skills__titles">
                                <h3 class="skills_name">Linux & VPS</h3>
                                <span class="skills__number">80%</span>
                            </div>
                            <div class="skills__bar">
                                <span class="skills__percentage skills__linux"></span>
                            </div>
                        </div>
                        <div class="skills__data">
                            <div class="skills__titles">
                                <h3 class="skills_name">Google Cloud Platform (GCP)</h3>
                                <span class="skills__number">75%</span>
                            </div>
                            <div class="skills__bar">
                                <span class="skills__percentage skills__gcp"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Tools & Testing -->
            <div>
                <div class="skills__content skills__close">
                    <div class="skills__header">
                        <i class="uil uil-wrench skills__icon"></i>
                        <div>
                            <h3 class="skills__title">Tools & Quality</h3>
                            <span class="skills__subtitle">More than 2 years</span>
                        </div>
                        <i class="uil uil-angle-down skills__arrow"></i>
                    </div>
                    <div class="skills__list grid">
                        <div class="skills__data">
                            <div class="skills__titles">
                                <h3 class="skills_name">Git & GitHub</h3>
                                <span class="skills__number">85%</span>
                            </div>
                            <div class="skills__bar">
                                <span class="skills__percentage skills__github"></span>
                            </div>
                        </div>
                        <div class="skills__data">
                            <div class="skills__titles">
                                <h3 class="skills_name">Postman</h3>
                                <span class="skills__number">85%</span>
                            </div>
                            <div class="skills__bar">
                                <span class="skills__percentage skills__postman"></span>
                            </div>
                        </div>
                        <div class="skills__data">
                            <div class="skills__titles">
                                <h3 class="skills_name">Cypress & Playwright</h3>
                                <span class="skills__number">75%</span>
                            </div>
                            <div class="skills__bar">
                                <span class="skills__percentage skills__cypress"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Design Tools -->
            <div>
                <div class="skills__content skills__close">
                    <div class="skills__header">
                        <i class="uil uil-swatchbook skills__icon"></i>
                        <div>
                            <h3 class="skills__title">Design Tools</h3>
                            <span class="skills__subtitle">More than 1 year</span>
                        </div>
                        <i class="uil uil-angle-down skills__arrow"></i>
                    </div>
                    <div class="skills__list grid">
                        <div class="skills__data">
                            <div class="skills__titles">
                                <h3 class="skills_name">Canva</h3>
                                <span class="skills__number">90%</span>
                            </div>
                            <div class="skills__bar">
                                <span class="skills__percentage skills__canva"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'Skills'
}
</script>
